import { createTheme } from '@mui/material/styles';

export const customButtonTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background: '#164C8A',
          fontSize: '10px',
          fontWeight: 400,
          border: 'none',
          '&:hover': {
            background: '#6E759B',
          },
          '@media (min-width: 1000px)': {
            fontSize: '14px',
          },
        },
      },
    },
  },
});

export const customButtonThemeBigger = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background: '#164C8A',
          fontSize: '14px',
          fontWeight: 400,
          border: 'none',
          '&:hover': {
            background: '#6E759B',
          },
          '@media (min-width: 1000px)': {
            fontSize: '18px',
          },
        },
      },
    },
  },
});

export const customButtonThemeBig = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          width: '100%',
          height: '55px',
          margin: '10px 0 0 0',
          fontSize: '12px',
          background: '#ef4161',
          '&:hover': {
            background: '#ee2b4f',
          },
          '@media (min-width: 1000px)': {
            width: '100px',
            margin: '0 0 0 10px',
            fontSize: '16px',
          },
        },
      },
    },
  },
});

export const customButtonErrorTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background: '#d32f2f',
          color: '#fff',
          fontSize: '10px',
          fontWeight: 400,
          border: 'none',
          '&:hover': {
            background: '#900',
          },
          '@media (min-width: 1000px)': {
            fontSize: '14px',
          },
        },
      },
    },
  },
});

export const simpleButtonTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background: '#ffffff',
          fontSize: '10px',
          color: '#164C8A',
          boxShadow: 'none',
          border: '1px solid #164C8A',
          fontWeight: 400,
          '&:hover': {
            background: '#efefef',
          },
          '@media (min-width: 1000px)': {
            fontSize: '14px',
          },
        },
      },
    },
  },
});
